import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-wizard', 'completedStep', 'Samm täidetud');
Labels.set('ui-wizard', 'next', 'Edasi');
Labels.set('ui-wizard', 'back', 'Tagasi');
Labels.set('ui-wizard', 'cancel', 'Tühista');
